var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFifty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 34,
    viewBox: "0 0 20 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "91q4np46za",
    d: "M0.747 0.465L3.362 0.465 3.362 6.964 0.747 6.964z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "fqoj04i4tc",
    d: "M0.442 0.465L3.056 0.465 3.056 6.964 0.442 6.964z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M9.49 14.024s-1.52-2.403-.356-4.065c1.165-1.66.97-2.435.97-2.435s2.443 2.42.372 6.484c-.016-2.339-.582-2.226-.582-2.226s-.566-.21-.404 2.242",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M10.006 14.724V12.79H9.86v1.932c-.43-.004-.592-.04-1.1-.155-.008-.19 0 17.368 0 17.368h2.342V14.567s-.259.147-1.095.157m-.423 1.5c.232 0 .419.186.419.417 0 .23-.188.418-.419.418-.231 0-.42-.187-.42-.418 0-.23.189-.417.42-.417m0 4.475c.232 0 .419.186.419.417 0 .23-.188.418-.419.418-.231 0-.42-.187-.42-.418 0-.231.189-.417.42-.417m.628 2.995c0 .115-.093.209-.21.209-.114 0-.208-.094-.208-.21 0-.114.094-.208.209-.208.116 0 .21.094.21.209m-1.048 2.122c0-.23.188-.418.42-.418.23 0 .418.188.418.418 0 .231-.188.419-.419.419-.231 0-.42-.188-.42-.419m.839 4.682c-.174 0-.314-.14-.314-.313s.14-.314.314-.314c.173 0 .314.14.314.314 0 .173-.14.313-.314.313m.42-3.435c-.078 0-.141-.063-.141-.14 0-.077.063-.14.14-.14.078 0 .14.063.14.14 0 .077-.063.14-.14.14m-.21-7.371c-.347 0-.628-.281-.628-.628 0-.345.281-.626.628-.626.348 0 .629.28.629.626 0 .347-.281.628-.629.628M18.184 14.024s-1.52-2.403-.355-4.065c1.165-1.66.97-2.435.97-2.435s2.443 2.42.372 6.484c-.016-2.339-.582-2.226-.582-2.226s-.566-.21-.404 2.242",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M19.87 28.883V26.98l-2.344 1.944.001 1.903 2.343-1.943zM17.525 23.66v1.903l2.345-1.944v-1.904l-2.345 1.945zM19.87 15.722v-1.155s-.26.147-1.096.157V12.79h-.147v1.932c-.43-.004-.591-.04-1.099-.155-.003-.052-.004 1.224-.004 3.1l2.346-1.945zM17.526 26.291v1.904l2.344-1.944v-1.905l-2.344 1.945zM17.528 31.554v.38h2.341v-2.323l-2.341 1.943zM17.524 18.396V20.3l2.346-1.946V16.45l-2.346 1.946zM17.524 21.028v1.904l2.345-1.946v-1.904l-2.345 1.946z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(3.6 .435)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gqwlgz8yvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#91q4np46za"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M1.542 6.964S.022 4.561 1.187 2.9c1.164-1.661.97-2.435.97-2.435s2.442 2.419.372 6.483c-.017-2.338-.583-2.225-.583-2.225s-.566-.21-.404 2.241",
    mask: "url(#gqwlgz8yvb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M6.827 22.26v-1.905l-2.343 1.944v1.903l2.343-1.943zM4.482 17.035l.001 1.904 2.345-1.944V15.09l-2.346 1.945z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M6.827 9.097V7.943s-.259.146-1.095.156V6.165h-.147v1.933c-.43-.004-.592-.04-1.1-.155-.002-.052-.003 1.224-.003 3.1l2.345-1.946zM4.483 19.667l.001 1.903 2.344-1.944v-1.904l-2.345 1.945zM4.485 24.93v.38h2.342v-2.323L4.485 24.93z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M4.482 11.771v1.905l2.346-1.946V9.826L4.482 11.77z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M4.482 14.403v1.905l2.345-1.946v-1.904l-2.345 1.945z",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1) translate(12.6 .435)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n2ch36ztid",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fqoj04i4tc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M1.237 6.964S-.283 4.561.882 2.9c1.164-1.661.97-2.435.97-2.435s2.442 2.419.371 6.483c-.016-2.338-.582-2.225-.582-2.225s-.566-.21-.404 2.241",
    mask: "url(#n2ch36ztid)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M14.979 16.45c-.027 0-.053-.01-.073-.029l-.553-.552-.559.558c-.02.02-.046.031-.073.031-.026 0-.052-.01-.072-.03l-.474-.472.001 1.733.545.544.56-.557c.02-.02.045-.03.072-.03.028 0 .054.01.073.03l.553.55.542-.54v-1.733l-.47.468c-.02.019-.045.03-.072.03",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M14.979 18.474c-.027 0-.053-.01-.073-.03l-.553-.551-.559.558c-.02.02-.046.03-.073.03-.026 0-.052-.01-.072-.03l-.473-.472v1.734l.545.543.56-.557c.02-.02.045-.03.072-.03.028 0 .054.01.073.03l.553.55.542-.54v-1.733l-.47.468c-.02.02-.045.03-.072.03M14.979 14.428c-.027 0-.053-.011-.073-.03l-.553-.552-.559.558c-.02.02-.046.03-.073.03-.026 0-.052-.01-.072-.03l-.474-.472v1.733l.546.545.56-.558c.02-.02.045-.03.072-.03.028 0 .054.01.073.03l.553.551.542-.54V13.93l-.47.468c-.02.019-.045.03-.072.03",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M14.979 20.497c-.027 0-.053-.01-.073-.03l-.553-.551-.559.558c-.02.02-.046.03-.073.03-.026 0-.052-.01-.072-.03l-.472-.47v1.734l.544.542.56-.558c.02-.02.045-.03.072-.03.028 0 .054.01.073.03l.553.551.542-.54V20l-.47.468c-.02.019-.045.03-.072.03M15.051 24.514c-.018.019-.045.03-.072.03-.027 0-.054-.011-.073-.03l-.552-.55-.56.557c-.02.02-.046.03-.073.03-.026 0-.052-.01-.072-.03l-.47-.47v1.26h2.341v-1.265l-.469.468zM13.721 10.14l.56-.558c.02-.019.045-.03.072-.03.028 0 .054.011.073.03l.553.55.542-.54v-1.65s-.259.147-1.096.157V6.166h-.147v1.931c-.43-.004-.592-.04-1.1-.155-.001-.037-.002.605-.003 1.654l.546.544zM14.979 12.404c-.027 0-.053-.01-.073-.03l-.553-.551-.559.558c-.02.02-.046.03-.073.03-.026 0-.052-.01-.072-.03l-.474-.473v1.734l.546.545.56-.558c.02-.02.045-.03.072-.03.028 0 .054.01.073.03l.553.55.542-.54v-1.733l-.47.468c-.02.02-.045.03-.072.03",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8752A1",
    d: "M14.28 23.745c.02-.019.047-.03.074-.03.027 0 .053.011.073.03l.552.551.542-.54v-1.733l-.47.468c-.019.019-.045.03-.072.03-.028 0-.054-.011-.073-.03l-.552-.551-.56.558c-.02.02-.046.03-.072.03-.027 0-.053-.01-.073-.03l-.472-.47.001 1.733.544.542.559-.558zM14.979 10.38c-.027 0-.053-.01-.073-.029l-.553-.552-.559.558c-.02.021-.046.031-.073.031-.026 0-.052-.01-.072-.03l-.474-.472v1.732l.546.546.56-.558c.02-.02.045-.03.072-.03.028 0 .054.01.073.03l.553.55.542-.54V9.883l-.47.468c-.02.02-.045.03-.072.03M.795 14.024S-.725 11.62.439 9.959c1.165-1.66.97-2.435.97-2.435s2.443 2.42.372 6.484c-.016-2.339-.582-2.226-.582-2.226s-.566-.21-.404 2.242",
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M1.384 14.724V12.79h-.147v1.932c-.43-.004-.591-.04-1.099-.155-.009-.19 0 17.368 0 17.368H2.48V14.567s-.259.147-1.096.157",
    transform: "translate(0 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifty);
export default __webpack_public_path__ + "static/media/fifty.f5c9f3c6ba8c4566fba9ba6676f0acfe.svg";
export { ForwardRef as ReactComponent };